import React from "react";
import type { PackageIconModel, PackageType } from "../../type/package";
import "./packageIcon.scss";

const ICONS: Record<PackageType, string> = {
  none: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/>
      <line x1="7" y1="12" x2="17" y2="12" stroke="currentColor" stroke-width="2"/>
    </svg>
  `,
  mini: `
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <path fill='black' d='M12 2C7 2 4 6 4 11c0 4 3 7 7 7s7-3 7-7c0-5-3-9-6-9z'/>
    </svg>
  `,
  standard: `
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <path fill='black' d='M12 2l10 5-10 5L2 7l10-5zm0 9l10 5-10 5-10-5 10-5z'/>
    </svg>
  `,
  max: `
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <path fill='black' d='M12 2c4 2 7 6 7 10l-4 4-4-4-4 4-4-4c0-4 3-8 7-10z'/>
    </svg>
  `,
  mega: `
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <path fill='black' d='M3 7l4 4 5-6 5 6 4-4v10H3V7z'/>
    </svg>
  `,
};

export const PackageIcon: React.FC<PackageIconModel> = ({
  type,
  width,
  height,
}) => {
  const safeType = type ?? "mini";
  const safeWidth = width ?? 58;
  const safeHeight = height ?? 58;

  const svg = encodeURIComponent(
    ICONS[safeType]?.trim()
  );

  return (
    <div
      className={`package-icon package-icon-${type ?? ""}`}
      style={{
        width: `${safeWidth}px`,
        height: `${safeHeight}px`,
        WebkitMaskImage: `url("data:image/svg+xml;utf8,${svg}")`,
        maskImage: `url("data:image/svg+xml;utf8,${svg}")`,
      }}
    />
  );
};
